import { PAGES } from '@/constants/pages';

export default {
  isSupplier(state, getters, rootState) {
    if (rootState.common.route?.name === PAGES.reclamations_supplier.name) {
      return true;
    }

    return false;
  },

  isDealers(state, getters, rootState) {
    if (rootState.common.route?.name === PAGES.reclamations_dealers.name) {
      return true;
    }

    return false;
  },

  isArchive(state, getters, rootState) {
    if (rootState.common.route?.query?.tab === 'archived') {
      return true;
    }

    return false;
  },

  canChange(state, getters, rootState) {
    const access = rootState.user.configAccess?.reclamations.main === 2;

    if (!getters.isArchive && getters.isDealers && access) {
      return true;
    }

    return false;
  },

  canArchived: (state, getters, rootState) => (status) => {
    if (!getters.isArchive && getters.isSupplier && status === 1) {
      return true;
    }

    return false;
  },

  filterStatuses(state) {
    let statuses = state.params.statuses
    
    if (statuses) {
      statuses = statuses.split(',');

      return state.statuses
        .filter(item => statuses.includes(`${item.id}`))
        .map(item => item.vendor_code);
    }

    return null;
  },
};
